import { provide as i, createBlock as o, openBlock as r, withCtx as a, createVNode as s, mergeProps as l, renderSlot as n } from "vue";
import { screenProp as m } from "../../utils/utilsScreen.js";
import d from "./utils/card-props.vue.js";
import k from "./components/clickable-wrapper.vue.js";
import p from "./components/card.vue.js";
const c = "DsCard", g = /* @__PURE__ */ Object.assign({
  name: c
}, {
  __name: "card",
  props: {
    ...d,
    ...m,
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return i("trackingData", { "component-name": c, title: t.title }), (e, u) => t.clickable && e.link ? (r(), o(k, {
      key: 0,
      link: e.link,
      "data-j-clickable": ""
    }, {
      default: a(() => [
        s(p, l({ ...e.$props, link: null }, { "data-j-clickable-card": "" }), {
          text: a(() => [
            n(e.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["link"])) : (r(), o(p, l({ key: 1 }, e.$props, { "data-j-card": "" }), {
      text: a(() => [
        n(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  g as default
};
